import { Mail, MapPin, Phone, Clock } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-16 md:py-24 bg-muted/40"
    >
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="chip mb-4">Get In Touch</div>
          <h2 className="font-heading uppercase text-3xl md:text-5xl font-bold tracking-tight text-secondary leading-tight">
            Got a job lined up?
            <br />
            <span className="text-orange-500">Let's talk.</span>
          </h2>
          <p className="mt-4 text-muted-foreground max-w-md">
            Send us a quick message or give us a call. We'll respond same day,
            most days.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-border border border-border">
          <ContactCard
            icon={Mail}
            label="Email"
            value="MrlPlantHire@gmail.com"
            href="mailto:MrlPlantHire@gmail.com"
            testId="contact-email"
          />
          <ContactCard
            icon={Phone}
            label="Phone"
            value={"0475 591 917\n0418 312 577"}
            href="tel:+61475591917"
            testId="contact-phone"
          />
          <ContactCard
            icon={MapPin}
            label="Location"
            value="Warragamba, NSW 2752"
            testId="contact-location"
          />
          <ContactCard
            icon={Clock}
            label="Hours"
            value={"Mon–Sat · 6:30am–6:00pm\nSun · By appointment"}
            testId="contact-hours"
          />
        </div>
      </div>
    </section>
  );
}

function ContactCard({ icon: Icon, label, value, href, testId }) {
  const content = (
    <div className="bg-white p-6 h-full flex flex-col gap-2 hover:bg-muted/30 transition-colors">
      <div className="flex items-center gap-2 text-orange-600">
        <Icon className="w-4 h-4" />
        <span className="text-[10px] uppercase tracking-[0.2em] font-heading">
          {label}
        </span>
      </div>
      <div className="font-heading uppercase text-lg tracking-tight whitespace-pre-line text-secondary">
        {value}
      </div>
    </div>
  );
  return href ? (
    <a href={href} data-testid={testId} className="block">
      {content}
    </a>
  ) : (
    <div data-testid={testId}>{content}</div>
  );
}
